import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { ArrowRight, CheckCircle2, FileSearch, Sparkles, ShieldCheck, FileText, ListChecks, Mail } from "lucide-react";

export default function HoeHetWerkt() {
  return (
    <div className="py-16" data-testid="how-it-works-page">
      <Seo path="/hoe-het-werkt" />
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto">
          <span className="text-xs font-semibold uppercase tracking-wider text-[#002FA7]">Hoe het werkt</span>
          <h1 className="font-display text-5xl sm:text-6xl font-bold text-ink mt-3 tracking-tight">
            Van document naar zekerheid in 5 simpele stappen.
          </h1>
          <p className="text-ink-soft text-lg mt-5">
            Geen ingewikkelde taal. Geen verborgen kosten. Een helder rapport dat je daadwerkelijk kan gebruiken aan tafel met de andere partij.
          </p>
        </div>

        <div className="mt-16 space-y-6">
          {[
            {
              step: "01", title: "Kies de juiste check", text: "Selecteer uit 19 specifieke checkers: HuurCheck voor je huurcontract, PolisCheck voor je verzekering, KredietCheck voor je leningsdossier… Elke checker heeft een eigen juridische context (BE & NL).",
              Icon: FileSearch,
            },
            {
              step: "02", title: "Upload of plak je document", text: "PDF, Word (.docx), foto (JPG, PNG, WEBP) of typ je tekst. Tot 20 MB. Versleuteld geüpload, 30 dagen bewaard, daarna automatisch verwijderd. Geen account vereist.",
              Icon: FileText,
            },
            {
              step: "03", title: "Onze AI vergelijkt in 60 seconden", text: "Onze AI leest je document, toetst het aan de actuele BE/NL-wetgeving en markttarieven en signaleert de kritieke punten — vóór je tekent.",
              Icon: Sparkles,
            },
            {
              step: "04", title: "Helder rapport met actiestappen", text: "Score 0–100. Alle bevindingen per ernstklasse (kritiek/hoog/aandacht/info/oké). Per bevinding een concrete actie en, waar relevant, de wettelijke onderbouwing.",
              Icon: ListChecks,
            },
            {
              step: "05", title: "Rapport bewaren of delen", text: "Print als PDF, e-mail naar je gezin of een specialist, of deel met een raadgever. Je rapport blijft 30 dagen beschikbaar via een unieke link.",
              Icon: Mail,
            },
          ].map(({ step, title, text, Icon }) => (
            <div key={step} className="rounded-2xl bg-white border border-border p-8 grid sm:grid-cols-12 gap-6 items-center">
              <div className="sm:col-span-1 flex sm:block">
                <span className="font-display text-5xl font-black text-[#002FA7]/15 leading-none">{step}</span>
              </div>
              <div className="sm:col-span-1">
                <div className="h-12 w-12 rounded-xl bg-slate-100 flex items-center justify-center text-[#002FA7]">
                  <Icon className="h-6 w-6" />
                </div>
              </div>
              <div className="sm:col-span-10">
                <h3 className="font-display text-2xl font-semibold text-ink">{title}</h3>
                <p className="text-ink-soft mt-2 leading-relaxed">{text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-4 text-center">
          {[
            { Icon: ShieldCheck, text: "GDPR-conform · 30 dagen retentie" },
            { Icon: CheckCircle2, text: "Onafhankelijk · geen commissies" },
            { Icon: Sparkles, text: "Aangedreven door Claude (Anthropic)" },
          ].map(({ Icon, text }) => (
            <div key={text} className="rounded-xl bg-white border border-border px-5 py-4 flex items-center justify-center gap-2 text-sm text-ink-soft">
              <Icon className="h-4 w-4 text-[#002FA7]" /> {text}
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <Link
            to="/#alle-checks"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#002FA7] hover:bg-[#0033B5] text-white font-semibold shadow-lg shadow-[#002FA7]/20 transition-colors"
            data-testid="how-it-works-cta"
          >
            Kies je check <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
